const config = {
  trackingCode: process.env.REACT_APP_GA_TRACKING_CODE || 'G-SDGY95CTJ6'
}

export default config
